import { Product } from '../..';
import {
  fixedIncomeAvailableProductsFiltersQuery,
  fixedIncomeAvailableProductsQuery,
} from '../../../../../../../../store/availableProducts/selectors';

import { FixedIncomeListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FixedIncomeProduct = () => {
  return (
    <Product
      productsQuery={fixedIncomeAvailableProductsQuery}
      customFiltersQuery={fixedIncomeAvailableProductsFiltersQuery}
      ProductItem={FixedIncomeListItem}
      ProductItemLoading={ListLoadingItem}
    />
  );
};
